import(/* webpackMode: "eager" */ "/home/runner/work/sixsense-website-v2/sixsense-website-v2/node_modules/next/dist/client/link.js");
